export default "__VITE_ASSET__q3v86GKS__"